import { render, staticRenderFns } from "./Control.vue?vue&type=template&id=c4f41a10"
import script from "./Control.vue?vue&type=script&setup=true&lang=js"
export * from "./Control.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../frontend.kantoor/app/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports